import React from "react";
import classNames from "classnames";
import FormField from "../FormField";
import useDefaultValueAs from "@/hooks/useDefaultValueAs";
import { SimpleFieldProps } from "../types";
import "./radio.scss";

export const RadioField = ({
  t,
  field,
  register,
  touchedFields,
  errors,
  setValue,
  values,
  className: classNameProp,
}: SimpleFieldProps) => {
  const dataQA = `${field.type}-${field.name}`;
  const radioButtonID = field.name;

  const className = classNames("radio", {
    [field.class as string]: typeof field.class === "string" && field.class.length > 0,
    [classNameProp as string]: classNameProp,
  });

  const validate = !errors[field.name]; // If there are no errors, validation is successful
  const validField = touchedFields?.[field?.name] && !errors[field.name]; // Field is valid if no errors and has a value

  useDefaultValueAs({ field: field, setValue: setValue, values: values });

  return (
    <FormField
      id={radioButtonID}
      label={t[field.label]}
      subLabel={field.subLabel && t[field.subLabel]}
      className={className}
      name={field.name}
      errorMessage={errors && errors[field.name] && t[errors[field.name]?.message as string]}
      tooltip={field.tooltip && t[field.tooltip]}
      validate={validate}
      validField={validField}>
      <div className="radio-wrapper">
        {field.options?.map((radioItem, index) => {
          const dataTestId = `radio-input-${radioItem.value}`;
          return (
            <div
              className="radio-label"
              key={`Radio-${index}`}>
              <div
                className="radio-container"
                id={radioButtonID}>
                <input
                  data-testid={dataTestId}
                  className="radio-input"
                  type="radio"
                  id={`${field.name}_${radioItem.value}`}
                  {...register(field.name, field.validation)}
                  value={radioItem.value}
                  data-qa={dataQA}
                />
                <label htmlFor={`${field.name}_${radioItem.value}`}>
                  {(radioItem.label && t[radioItem.label]) || radioItem.label}
                </label>
                {field.help && <div className="radio-help">{t[field.help] || field.help}</div>}
              </div>
            </div>
          );
        })}
      </div>
    </FormField>
  );
};
